import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review31_4 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>4</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. คำกล่าวเกี่ยวกับอาณาจักรทวารวดีในข้อใดถูกต้องที่สุด</h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เป็นอาณาจักรแห่งแรกในดินแดนไทย</h5>
                           <h5 className="textreviewF">ข. ช่วยถ่ายทอดวัฒนธรรมไปสู่ดินแดนอื่น</h5>
                           <h5 className="textreviewF">ค. นำดินแดนไทยเข้าสู่สมัยประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">3. การใช้คำบอกเวลาในข้อใดที่สามารถจะระบุเวลาที่เกิดเหตุการณ์ได้ชัดเจนที่สุด</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เดือน  ปี  ศักราช</h5>
                           <h5 className="textreviewF">ข. ยุคสมัย  ศตวรรษ</h5>
                           <h5 className="textreviewF">ค. กาลครั้งหนึ่งนานมาแล้ว</h5>
                           <h5 className="textreviewF">ง. ยุคก่อนประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">4. ปฐมกษัตริย์พระองค์แรกของอยุธยาคือใคร</h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. สมเด็จพระมหาธรรมราชา</h5>
                           <h5 className="textreviewT">ข. 1205  สมเด็จพระเจ้าอู่ทอง</h5>
                           <h5 className="textreviewF">ค. สมเด็จพระเจ้าทองลัน</h5>
                           <h5 className="textreviewF">ง. สมเด็จพระเจ้าปราสาททอง</h5>
                        </Form>

                        <h5 className="textreview">5. พระโอรสของพระเจ้าอู่ทองที่ได้ขึ้นครองราชย์ต่อจากพระองค์คือใคร</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. สมเด็จพระรามราชา</h5>
                           <h5 className="textreviewT">ข. สมเด็จพระราเมศวร</h5>
                           <h5 className="textreviewF">ค. พระเจ้าทองลัน</h5>
                           <h5 className="textreviewF">ง. ขุนหลวงพะงั่ว</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review31_4